export const ONE_SECOND_MS = 1000;
export const ONE_MINUTE_MS = 60 * ONE_SECOND_MS;
export const ONE_HOUR_MS = 60 * ONE_MINUTE_MS;
export const ONE_DAY_MS = 24 * ONE_HOUR_MS;

export const TWO_SECONDS_MS = 2 * ONE_SECOND_MS;
export const FIVE_SECONDS_MS = 5 * ONE_SECOND_MS;
export const TEN_SECONDS_MS = 10 * ONE_SECOND_MS;

export const TWO_MINUTES_MS = 2 * ONE_MINUTE_MS;
export const FIVE_MINUTES_MS = 5 * ONE_MINUTE_MS;
export const FIFTEEN_MINUTES_MS = 15 * ONE_MINUTE_MS;
export const THIRTY_MINUTES_MS = 30 * ONE_MINUTE_MS;
